import { css } from 'styled-components';
import {
  getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const breadcrumb: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, 0])}
  border-top: 1px solid ${theme.palettes.neutrals.light};
`;
